import { orderBy } from 'lodash'

export default {
  cookie: function (state) {
    if (typeof localStorage.getItem('hit_cookie_settings') === 'string' && localStorage.getItem('hit_cookie_settings').length) { return localStorage.getItem('hit_cookie_settings') }

    return state.cookie
  },
  loading: function (state) { return state.loading },
  page_colors: function (state) { return state.page.colors },
  unread_chats: function (state) { return state.unread_chats },
  unread_chatnr: function (state) {
    var r = []
    var c = []

    if (typeof state.unread_chats.messages === 'undefined') { return c }

    state.unread_chats.messages.forEach(function (v) {
      if (r.indexOf(v.chat_nr) == -1) {
        var chat_nr = v.chat_nr.split('-')
        r.push(v.chat_nr)
        c.push({settings: {board: chat_nr[0], ID: chat_nr[1]} })
      }
    })

    return c
  },
  mode: function (state) { return state.mode },
  lang: function (state) { return state.language },
  user: function (state) { return state.user },
  boards: function (state) { return state.boards },
  board_limits: function (state) {
    return {
      'premium': 0, 'base': 10
    }
  },
  votes: function (state) { return state.votes },
  board_avg: function (state) { return state.board_avg },
  feedback: function (state) { return state.feedback },
  badges: function (state) { return state.design.badges },
  votings: function (state) { return state.design.votings },
  page_title: function (state) { return state.page_title },
  target_pages: function (state) { return state.target_pages },
  boards_by_id: function (state) {
    var r = {}
    for (var i = 0; i < state.boards.length; i++) { r[ state.boards[i].ID ] = Object.assign(state.boards[i], {pos: i}) }

    return r
  }
}
